import {
    selectDoc,
    toggleClass,
    event,
    selectArr
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";
import {PCP} from "./component.pcp";
import {initFCollectionProductCard} from "./component.home";

const props = {
    fcSliders: selectArr('.fcol-slider')
}

const initTwoColSliders = () => {
    selectArr('.two-col-slider').map(slider => {
        let slides = selectArr('ul li', slider);
        if (slides.length > 1) {
            initSlider(`#${slider.id}`, {
                perView: 1,
                type: 'carousel',
                rewind: true,
                bound: true,
                hoverpause: false,
                animationDuration: 1000,
                peek: {
                    before: 0,
                    after: 0
                }
            }, true);
        } else {
            let controls = selectDoc('.slider-controls', slider);
            if (controls) {
                controls.parentNode.removeChild(controls);
            }
        }
    });
}

const insertLifeStyleCards = (pcpProducts) => {
    if (pcpProducts) {
        let cards = selectArr('.grid-mode .lifestyle');

        /**
         * Clean current cards
         */
        cards.map(card => {
            card.parentNode.removeChild(card);
        })

        /**
         * Re-add cards
         */
        cards.map(lifecard => {
            let position = parseInt(lifecard.getAttribute('data-pos'));
            if (pcpProducts.length < position) {
                position = (pcpProducts.length + 1);
            }

            pcpProducts.map((product, index) => {
                if ((index + 1) == (position - 1)) {
                    let newCard = lifecard.cloneNode(true);
                    product.parentNode.insertBefore(newCard, product.nextSibling);
                }
            })
        })
    }
}

const initVideo = () => {
    let videos = selectArr('#mp4-video-marketing'),
        action = selectDoc('#mp4-video-marketing-action'),
        pause = true;

    event(action, 'click', function () {
        toggleClass(action, 'pause');
        videos.map(vid => {
            if (pause) {
                vid.pause();
            } else {
                vid.play();
            }
        })
        pause = !pause;
    });
}

const initializer = () => {
    selectArr('.products-slider').map(slider => {
        initSlider(`#${slider.id}`, {
            perView: 3,
            type: 'carousel',
            rewind: true,
            bound: true,
            hoverpause: false,
            animationDuration: 1000,
            peek: {
                before: 0,
                after: 0
            },
            breakpoints: {
                1024: {
                    perView:3
                },
                767: {
                    animationDuration: 500,
                    perView: 1,
                    gap: 10,
                    peek: {
                        before: 0,
                        after: 70
                    }
                }
            }
        }, true);
    });
    initFCollectionProductCard()

    initSlider(`#tds-marketing-slider`, {
        perView: 1,
        type: 'carousel',
        rewind: true,
        bound: true,
        hoverpause: true,
        animationDuration: 1000,
    }, true);

    initTwoColSliders();

    insertLifeStyleCards(selectArr('.grid-mode .product'));

    initVideo();
}

export const Marketing = {
    init: () => initializer()
}
